// The video_tag filter only emits the attributes it knows about, so sections mark their
// videos with a class instead. data-autoplay stays supported for hand-written markup.
const AUTOPLAY_SELECTOR = 'video.lazy-video, video[data-autoplay]'; 

// Cap the wait so a slow third party on the page can't hold the hero video back.
const START_TIMEOUT = 3000;

/**
 * The video_tag filter injects a fallback <img> inside <video> with no alt attribute and
 * exposes no parameter to label it. Browsers never render it, but axe reports it as an
 * image without alternative text.
 */
function labelPosterFallbacks(root) {
  root.querySelectorAll('video > img:not([alt])').forEach((img) => {
    img.alt = '';
    img.setAttribute('role', 'presentation');
  });
}

function play(video) {
  video.preload = 'auto';

  const attempt = video.play();
  if (attempt && typeof attempt.catch === 'function') {
    attempt.catch(() => {});
  }
}

function observe(videos) {
  if (!('IntersectionObserver' in window)) {
    videos.forEach(play);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        play(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '200px' }
  );

  // Hidden videos never report as intersecting, so the breakpoint the visitor is not on
  // stays untouched until it becomes visible.
  videos.forEach((video) => observer.observe(video));
}


function collect(root) {
  return Array.from(root.querySelectorAll(AUTOPLAY_SELECTOR));
}

function init() {
  const videos = collect(document);
  if (videos.length) observe(videos);
}

labelPosterFallbacks(document);

if (document.readyState === 'complete') {
  init();
} else {
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    init();
  };

  window.addEventListener('load', start, { once: true });
  setTimeout(start, START_TIMEOUT);
}

document.addEventListener('shopify:section:load', (event) => {
  labelPosterFallbacks(event.target);

  const videos = collect(event.target);
  if (videos.length) observe(videos);
});
